import Howl from 'howler';
 
const HowlerPlugin = {
  install(Vue, options) {
    Vue.prototype.$howler = {
      play: (src) => {
        const sound = new Howl({ src: [src] });
        sound.play();
      },
      stop: (id) => {
        Howl.stop(id);
      }
    };
  }
};
 
export default HowlerPlugin;